import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { AlertsConfig, ClientITProfile, Project } from 'src/app/_models';
import { DropdownItem } from 'src/app/helpers/dropdownItem';
import { Integration } from '../../_models/integration';

@Component({
    standalone: false,
  selector: 'edit-integration-app',
  templateUrl: './edit-integration-app.component.html',
  styleUrls: ['./edit-integration-app.component.css'],
})
export class EditIntegrationAppComponent implements OnInit, OnDestroy {
  private methodSubscription: Subscription;
  private categorySubscription: Subscription;

  form: FormGroup;
  projects: (Project & { itProfiles: ClientITProfile[] })[];
  sapProfiles: any[];
  sarProfiles: any[];
  authOptions: DropdownItem<string>[] = [
    { name: 'None', value: 'None' },
    { name: 'Token', value: 'Token' },
    { name: 'Username/Password', value: 'Password' },
  ];
  methodOptions: DropdownItem<string>[] = [
    { name: 'GET', value: 'GET' },
    { name: 'POST', value: 'POST' },
    { name: 'FILE', value: 'FILE' },
    { name: 'AWS Config', value: 'AWSConfig' },
    { name: 'AWS CloudTrail', value: 'AWSCloudTrail' },
    { name: 'S3 Download', value: 'S3Download' },
    { name: 'S3 Upload', value: 'S3Upload' },
    { name: 'WEB API', value: 'Generic' },
  ];
  getCategoryOptions: DropdownItem<string>[] = [
    { name: 'Evidence', value: 'Evidence' },
    { name: 'POAM', value: 'POAM' },
  ];
  postOrFileCategoryOptions: DropdownItem<string>[] = [
    { name: 'Catalog', value: 'OSCAL_Catalog' },
    { name: 'Profile', value: 'OSCAL_Profile' },
    { name: 'Category', value: 'OSCAL_Category' },
    { name: 'Implementation', value: 'OSCAL_Implementation' },
    { name: 'POAM', value: 'OSCAL_POAM' },
    { name: 'SAP', value: 'OSCAL_SAP' },
    { name: 'SAR', value: 'OSCAL_SAR' },
  ];

  integration: Integration;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public fb: FormBuilder
  ) {
    this.projects = this.config.data.projects;
    this.sapProfiles = this.config.data.sapProfiles;
    this.sarProfiles = this.config.data.sarProfiles;
  }

  ngOnInit(): void {
    this.integration = { ...(this.config.data.item ?? { authDetails: {} }) };
    this.initializeForm();
  }

  initializeForm() {
    this.form = this.fb.group({
      name: [''],
      type: [''],
      status: [''],
      url: [''],
      authDetails: this.fb.group({
        type: [''],
        token: [''],
        username: [''],
        password: [''],
      }),
      method: [''],
      category: [''],
      settings: this.fb.group({}),
      connectionSettings: this.fb.group({}),
      schedule: this.fb.group({
        period: [null],
        startDateTime: [null],
        endDateTime: [null],
        daysOfMonth: [[]],
        months: [[]],
        daysOfWeek: [[]],
        hours: [null],
        minutes: [null],
      }),
      httpMethod: [''],
    });

    this.methodSubscription = this.form
      .get('method')
      .valueChanges.subscribe((_) => {
        this.form.get('category').reset();
      });

    this.categorySubscription = this.form
      .get('category')
      .valueChanges.subscribe((_) => {
        const settingsGroup = this.form.get('settings') as FormGroup;

        Object.keys(settingsGroup.controls).forEach((name) =>
          settingsGroup.removeControl(name)
        );
      });

    this.form.patchValue(this.integration);
  }

  onSave() {
    const formData = this.form.value;
    const formSchedule = formData.schedule;
    const scheduleConverted: AlertsConfig = {
      ...formSchedule,
      daysOfMonth: formSchedule.daysOfMonth.map((i) => i.value),
      months: formSchedule.months.map((i) => i.value),
      daysOfWeek: formSchedule.daysOfWeek.map((i) => i.value) ?? {},
    };
    const formDataValue = {
      ...this.integration,
      ...formData,
      schedule: { ...scheduleConverted },
    } as Integration;

    this.dialogRef.close(formDataValue);
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.methodSubscription?.unsubscribe();
    this.categorySubscription?.unsubscribe();
  }
}
